import { Title } from "../../components/base/Title";


export default function PolitiqueConfidentialite() {
  return (
    <div className="p-6 max-w-4xl mx-auto leading-relaxed">
      <Title type="subdisplay" centered>Politique de confidentialité</Title>
      <p className="text-gray-600 mb-8 text-center">
        <strong>Dernière mise à jour :</strong> 18 octobre 2025
      </p>
      <div className="space-y-8">
        <section>

          <p>
            Le Rucher de Carole et Sylvain s'engage à protéger la confidentialité et la sécurité des données personnelles de ses utilisateurs.
            Cette politique de confidentialité explique comment nous collectons, utilisons, stockons et protégeons vos informations personnelles
            conformément au Règlement Général sur la Protection des Données (RGPD).
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">1. Responsable du traitement</Title>
          <p>
            Le responsable du traitement des données personnelles est Le Rucher de Carole et Sylvain,
            plateforme de commande et de livraison de miel pour les communautés.
          </p>
          <p className="mt-2">
            <strong>Contact :</strong> Pour toute question concernant cette politique de confidentialité ou vos données personnelles,
            vous pouvez contacter le service technique par e-mail à l'adresse <a href="mailto:marionlebas.dev@gmail.com" className="text-primary-600 hover:underline">marionlebas.dev@gmail.com</a>.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">2. Données personnelles collectées</Title>
          <p className="mb-4">Nous collectons les données personnelles suivantes :</p>

          <div className="space-y-3">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Données d'identification :</Title>
              <ul className="list-disc list-inside space-y-1 text-gray-700">
                <li>Nom et prénom (obligatoires)</li>
                <li>Adresse e-mail (obligatoire)</li>
                <li>Numéro de téléphone (optionnel)</li>
              </ul>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Données de connexion :</Title>
              <ul className="list-disc list-inside space-y-1 text-gray-700">
                <li>Mot de passe (stocké de manière chiffrée)</li>
                <li>Token de session (pour maintenir votre connexion)</li>
              </ul>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Données d'activité :</Title>
              <ul className="list-disc list-inside space-y-1 text-gray-700">
                <li>Groupe d'appartenance (pour l'organisation des livraisons)</li>
                <li>Statut utilisateur (client, référent, administrateur)</li>
                <li>Historique des commandes et paniers</li>
                <li>Données de livraison (adresse via le groupe)</li>
              </ul>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Données de paiement :</Title>
              <ul className="list-disc list-inside space-y-1 text-gray-700">
                <li>Informations de paiement traitées par Stripe (numéro de carte masqué, nom du titulaire)</li>
                <li>Identifiant de transaction Stripe</li>
                <li>Statut de paiement et historique des transactions</li>
                <li>Données de facturation (si différentes de l'adresse de livraison)</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">3. Finalités du traitement</Title>
          <p className="mb-4">Vos données personnelles sont utilisées pour :</p>


          <div className="space-y-3">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Gestion de votre compte</Title>
              <p>Création, authentification et gestion de votre compte utilisateur</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Traitement des commandes</Title>
              <p>Enregistrement et suivi de vos commandes, gestion des paniers</p>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Traitement des paiements</Title>
              <p>Gestion des paiements via Stripe, suivi des transactions et remboursements</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Organisation des livraisons</Title>
              <p>Rattachement à un groupe de livraison et coordination avec votre référent</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Communication</Title>
              <p>Envoi d'informations relatives à vos commandes et aux livraisons</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Gestion administrative</Title>
              <p>Gestion des référents, administration de la plateforme</p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">4. Base légale du traitement</Title>
          <p className="mb-4">Le traitement de vos données personnelles est fondé sur :</p>

          <div className="space-y-3">
            <div className="flex items-center gap-x-3">
              <div className="w-6 h-6 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold">1</div>
              <div className="border border-gray-200 rounded-lg p-4 flex-1">
                <Title type="h3" className="font-semibold">Exécution du contrat</Title>
                <p>Nécessaire à l'exécution de la commande et à la fourniture du service</p>
              </div>
            </div>

            <div className="flex items-center gap-x-3">
              <div className="w-6 h-6 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold">2</div>
              <div className="border border-gray-200 rounded-lg p-4 flex-1">
                <Title type="h3" className="font-semibold">Intérêt légitime</Title>
                <p>Amélioration du service et gestion de la relation client</p>
              </div>
            </div>

            <div className="flex items-center gap-x-3">
              <div className="w-6 h-6 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold">3</div>
              <div className="border border-gray-200 rounded-lg p-4 flex-1">
                <Title type="h3" className="font-semibold">Consentement</Title>
                <p>Pour les communications marketing (si applicable)</p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">5. Partage des données</Title>
          <p className="mb-4">Vos données personnelles ne sont partagées qu'avec :</p>

          <div className="space-y-3">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Référents de livraison</Title>
              <p>Les référents de votre groupe peuvent voir votre nom, prénom et commandes pour organiser la distribution</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Administrateurs</Title>
              <p>L'équipe administrative a accès aux données nécessaires à la gestion de la plateforme</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Prestataires techniques</Title>
              <p>Nos hébergeurs et prestataires techniques (sous contrat de confidentialité)</p>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Stripe (paiements)</Title>
              <p>
                Données de paiement partagées avec Stripe pour le traitement sécurisé des transactions. 
                Stripe est certifié PCI DSS et conforme au RGPD. 
                <a href="https://stripe.com/fr/privacy" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline ml-1">
                  Voir la politique de confidentialité de Stripe
                </a>
              </p>
            </div>
          </div>

          <p className="mt-4 p-4 bg-gray-100 border border-gray-300 rounded-lg">
            <strong>Engagement :</strong> Nous ne vendons, ne louons ni ne partageons vos données avec des tiers à des fins commerciales.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">6. Sécurité des données</Title>
          <p className="mb-4">Nous mettons en œuvre des mesures de sécurité appropriées :</p>

          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <Title type="h3" className="font-semibold mb-2">Chiffrement</Title>
              <p>Mots de passe hashés, connexions HTTPS sécurisées</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <Title type="h3" className="font-semibold mb-2">Accès restreint</Title>
              <p>Accès aux données limité aux personnes autorisées</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <Title type="h3" className="font-semibold mb-2">Sauvegardes</Title>
              <p>Sauvegardes régulières et sécurisées des données</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <Title type="h3" className="font-semibold mb-2">Monitoring</Title>
              <p>Surveillance des accès et détection d'intrusions</p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">7. Vos droits</Title>
          <p className="mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>

          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-4 h-4 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold" />
              <div>
                <Title type="h3" className="font-semibold">Droit d'accès</Title>
                <p>Consulter vos données personnelles</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-4 h-4 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold" />
              <div>
                <Title type="h3" className="font-semibold">Droit de rectification</Title>
                <p>Corriger ou mettre à jour vos informations</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-4 h-4 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold" />
              <div>
                <Title type="h3" className="font-semibold">Droit à l'effacement</Title>
                <p>Demander la suppression de vos données</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-4 h-4 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold" />
              <div>
                <Title type="h3" className="font-semibold">Droit à la portabilité</Title>
                <p>Récupérer vos données dans un format structuré</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-4 h-4 bg-primary-300 rounded-full flex items-center justify-center text-sm font-bold" />
              <div>
                <Title type="h3" className="font-semibold">Droit d'opposition</Title>
                <p>Vous opposer au traitement de vos données</p>
              </div>
            </div>
          </div>

          <p className="mt-4 p-4 bg-gray-100 border border-gray-300 rounded-lg">
            <strong>Comment exercer vos droits :</strong> Contactez le service technique par e-mail à l'adresse <a href="mailto:marionlebas.dev@gmail.com" className="text-primary-600 hover:underline">marionlebas.dev@gmail.com</a>.
            Nous vous répondrons dans un délai maximum d'un mois.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">8. Cookies et technologies similaires</Title>
          <p className="mb-4">
            Notre plateforme utilise des cookies techniques nécessaires au bon fonctionnement du service :
          </p>

          <div className="bg-gray-50 p-4 rounded-lg">
            <ul className="space-y-2 text-gray-700">
              <li><strong>Cookies de session :</strong> Maintien de votre connexion</li>
              <li><strong>Cookies de sécurité :</strong> Protection contre les attaques CSRF</li>
              <li><strong>Cookies de préférences :</strong> Mémorisation de vos choix d'interface</li>
            </ul>
          </div>

          <p className="mt-4">
            Ces cookies sont essentiels au fonctionnement de la plateforme et ne nécessitent pas votre consentement.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">9. Modifications de cette politique</Title>
          <p>
            Cette politique de confidentialité peut être modifiée pour refléter les évolutions de nos pratiques
            ou de la réglementation. Toute modification importante vous sera notifiée via la plateforme
            ou par e-mail. Nous vous encourageons à consulter régulièrement cette page.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">10. Contact et réclamations</Title>
          <p className="mb-4">
            Pour toute question concernant cette politique de confidentialité ou le traitement de vos données :
          </p>

          <div className="bg-primary-50 p-4 rounded-lg">
            <p className="font-semibold mb-2">Contact interne :</p>
            <p>Par e-mail à l'adresse <a href="mailto:contact.leruchernormand@gmail.com" className="text-primary-600 hover:underline">contact.leruchernormand@gmail.com</a>.</p>

            <p className="font-semibold mb-2 mt-4">Autorité de contrôle :</p>
            <p>
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez saisir la CNIL :<br />
              <strong>CNIL</strong> - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07<br />
              Tél : 01 53 73 22 22 - www.cnil.fr
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
